export default ({ data: { store } }, { market, t }) => {
  if (!store) {
    return {};
  }

  const meta = { name: store.name };
  const structuredData = {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name: store.name,
    url: market.domain + store.pathName,
  };

  // Only add ratings if there is a set rating value
  if (store.userReviewSummary.count && store.userReviewSummary.rating) {
    const url =
      market.domain +
      store.pathName +
      (store.userReviews.pageInfo.offset
        ? `?offset=${store.userReviews.pageInfo.offset}`
        : '');
    structuredData.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: parseFloat((store.userReviewSummary.rating / 2).toFixed(1)), // Convert rating
      url,
      ratingCount: store.userReviewSummary.count,
      worstRating: 0,
      bestRating: 5,
      name: t('reviews', 'panel.title'),
    };

    // Overwrite the main url with the offset url
    structuredData.url = url;

    // Add the reviews
    // @NOTE: Do not include "reviewBody: item.reviewText," (potential XSS).
    structuredData.review = store.userReviews.nodes.map(item => ({
      '@type': 'Review',
      datePublished: item.updatedAt,
      reviewRating: {
        '@type': 'Rating',
        worstRating: 0,
        bestRating: 5,
        ratingValue: parseFloat((item.rating / 2).toFixed(1)), // Convert rating
      },
      author: {
        '@type': 'Person',
        // @NOTE: This assumes display names are validated (!)
        name: item.user ? item.user.name : t('reviews', 'user.anonymous'),
      },
    }));
  }

  // TODO: Less hacky solution
  const storeLogoUrl = `${market.imageCdnUrl}image/store/${store.id}.png?w=88`;

  const openGraph = [
    {
      key: 'title',
      content: t('meta', 'store.og-title', { name: store.name }),
    },
    {
      key: 'url',
      content: market.domain + store.pathName,
    },
    { key: 'type', content: 'company' },
    { key: 'image', content: storeLogoUrl },
  ];

  return {
    title: t('meta', 'store.title', meta),
    description: t('meta', 'store.description', meta),
    thumbnail: storeLogoUrl,
    canonical: market.domain + store.pathName,
    structuredData,
    openGraph,
    android: store.pathName,
    ios: `/store/${store.id}`, // TODO: Semantic id when app can handle it
    hrefLang: store.hrefLang,
  };
};
